// extracted by mini-css-extract-plugin
export default {"wrapper":"Chart_wrapper__FxNAa","inner":"Chart_inner__Pe+f+","description":"Chart_description__FyKME","title":"Chart_title__Uk+iI","sub-title":"Chart_sub-title__cPdoX"};